/* eslint-disable jsx-a11y/click-events-have-key-events */
import { memo, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { isNil, isFunction, keys, cloneDeep, isString, isEmpty, trim } from 'lodash';
// Import Configs
import { infoItemsConfig } from './config';
// Import Constants
import { l } from 'constants/common';
// Import Hooks
import useHasPermission from 'hooks/UseHasPermission';
import { usePartnerDateFormats } from 'hooks/UsePartnerDateFormats';
//Import Components
import KeyValueItems from 'components/common/KeyValueItems';

const CustomerJourneyGeneralDetails = (props) => {
    const { t } = useTranslation();
    const { partnerDateTimeFormat } = usePartnerDateFormats();
    const { hasPartnerSettings, hasPermission } = useHasPermission();
    const infoItems = infoItemsConfig(t, partnerDateTimeFormat, hasPartnerSettings, hasPermission);

    const getInfoItems = useCallback(() => {
        return keys(props)
            .filter((propKey) => !isNil(infoItems[propKey]) && !infoItems[propKey].hidden)
            .map((propKey) => {
                const itemConfig = cloneDeep(infoItems[propKey]);
                itemConfig.isLoading = propKey === 'usedIn' ? props.isLoadingUsedIn : props.isLoading;
                itemConfig.value =
                    isNil(props[propKey]) || (isString(props[propKey]) && isEmpty(trim(props[propKey])))
                        ? t(l.NA)
                        : isFunction(itemConfig.format)
                          ? itemConfig.format(props[propKey])
                          : isFunction(itemConfig.renderer)
                            ? itemConfig.renderer(props[propKey])
                            : props[propKey];
                return itemConfig;
            });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props]);

    const customFieldsUI = useMemo(() => {
        return props.customFields.map((field) => ({
            label: field.ViewData.Name,
            value: field.ViewData.Value ?? field.FieldValue,
            isLoading: false,
        }));
    }, [props.customFields]);

    return (
        <>
            <div className="key-value-items-details-section">
                <div className="title-wrapper">
                    <p className="title-wrapper-text">{t(l.GeneralDetails)}</p>
                    <span className="title-wrapper-line" />
                </div>
                <div className="general-details-content">
                    <div className="general-details-column">
                        <KeyValueItems items={getInfoItems()} />
                        {!isEmpty(customFieldsUI) && <KeyValueItems items={customFieldsUI} />}
                    </div>
                </div>
            </div>
        </>
    );
};

CustomerJourneyGeneralDetails.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    mode: PropTypes.number,
    status: PropTypes.number,
    User: PropTypes.string,
    createdDate: PropTypes.string,
    lastModified: PropTypes.string,
    lastModifier: PropTypes.string,
    usedIn: PropTypes.array,
    customFields: PropTypes.array,
    isLoadingUsedIn: PropTypes.bool,
    isLoading: PropTypes.bool,
    workflowId: PropTypes.number,
    predefinedRegions: PropTypes.string,
    predefinedCategories: PropTypes.string,
    hasBudget: PropTypes.bool,
};

CustomerJourneyGeneralDetails.defaultProps = {
    customFields: [],
};

export default memo(CustomerJourneyGeneralDetails);
